import { CameraOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Badge, Image, Space, Tag, Tooltip } from "antd";
import { StatusTag } from "@/shared/components/StatusTag";
import { resolveImageUrl } from "@/shared/utils/resolveImageUrl";
import type { PeriodSlotDisplay } from "../types";

interface EventBadgeDisplay {
	insideTerritory?: boolean | null;
	photoUrl?: string | null;
	noPhotoFlag?: boolean;
	noGeofenceFlag?: boolean;
}

/** Geofence badge + photo thumbnail shared by the enter/exit cells */
export function EventBadges({ display }: { display: EventBadgeDisplay }) {
	const geofence =
		display.insideTerritory === true ? (
			<Tooltip title="Hudud ichida">
				<EnvironmentOutlined style={{ color: "#52c41a" }} />
			</Tooltip>
		) : display.insideTerritory === false ? (
			<Tooltip title="Hudud tashqarisida">
				<EnvironmentOutlined style={{ color: "#ff4d4f" }} />
			</Tooltip>
		) : display.noGeofenceFlag ? (
			<Tooltip title="Hudud tasdiqlanmagan">
				<EnvironmentOutlined style={{ color: "#bfbfbf" }} />
			</Tooltip>
		) : null;

	const photo = display.photoUrl ? (
		<Image
			width={20}
			height={20}
			src={resolveImageUrl(display.photoUrl)}
			alt="Foto"
			style={{ objectFit: "cover", borderRadius: 2 }}
		/>
	) : display.noPhotoFlag ? (
		<Tooltip title="Foto yo'q">
			<CameraOutlined style={{ color: "#bfbfbf" }} />
		</Tooltip>
	) : null;

	if (!(geofence || photo)) {
		return null;
	}
	return (
		<Space size={4}>
			{geofence}
			{photo}
		</Space>
	);
}

export function PeriodSlotCell({ display }: { display: PeriodSlotDisplay }) {
	if (display.isEmpty) {
		return (
			<div className="text-center">
				<Badge status="error" />
			</div>
		);
	}
	return (
		<div className="text-center">
			<Space size={4} align="center">
				{display.isManual ? (
					<Tooltip title="Qo'lda kiritilgan">
						<Tag color="blue">{display.time}</Tag>
					</Tooltip>
				) : (
					<StatusTag tone="success">{display.time}</StatusTag>
				)}
				<EventBadges
					display={{
						insideTerritory: display.insideTerritory,
						photoUrl: display.photoUrl,
						noPhotoFlag: !display.photoUrl,
						noGeofenceFlag: display.insideTerritory == null,
					}}
				/>
			</Space>
		</div>
	);
}
